import axios from "axios";
import { useAppContext } from "../../context/AuthContext";
import TicketDto from "../../model/ticket/TicketDto";
import Endpoints from "../../utils/Endpoints";
import { axiosConfig } from "../../utils/Utils";

interface TicketControllerType {
  axiosGetTicketList: any;
  axiosGetTicketById: any;
  axiosTicketSave: any;
  axiosTicketResponse: any;
  axiosTicketDelete: any;
  axiosGetReviewTicketList: any;
}

export function TicketController(): TicketControllerType {
  const { authData } = useAppContext();

  const axiosGetTicketList = () => {
    return axios.get(Endpoints.TICKET + "/my-list", axiosConfig(authData!.token));
  };

  const axiosTicketSave = (ticket: TicketDto) => {
    return axios.post(Endpoints.TICKET + "/save", ticket, axiosConfig(authData!.token));
  };

  const axiosTicketResponse = (id: number, content: string) => {
    return axios.post(`${Endpoints.TICKET}/${id}/response`, content, axiosConfig(authData!.token));
  };

  const axiosGetTicketById = (id: number) => {
    return axios.get(Endpoints.TICKET + "/" + id, axiosConfig(authData!.token));
  };

  const axiosTicketDelete = (id: number) => {
    return axios.post(Endpoints.TICKET + "/" + id, {}, axiosConfig(authData!.token));
  };

  const axiosGetReviewTicketList = () => {
    return axios.get(Endpoints.TICKET + "/all-list", axiosConfig(authData!.token));
  };

  return {
    axiosGetTicketList,
    axiosGetTicketById,
    axiosTicketSave,
    axiosTicketResponse,
    axiosTicketDelete,
    axiosGetReviewTicketList,
  };
}

export type { TicketControllerType };
